import React, { useState, useEffect } from "react";
import { Configurations } from "../../../Utils/Configurations";
import { Nav, NavItem, TabContent, TabPane, NavLink } from "reactstrap";
import './Cile-Content.scss';
import axios from "axios";
import ContentCileList from "../../../Components/Content-Cile-List/Content-Cile-List";
import { withRouter } from 'react-router-dom';

const CileContentBanners = ({ history }) => {

    const [banners, setBanners] = useState([])
    const [loading, setLoading] = useState(true)
    const [abaSelecionada, setAbaSelecionada] = useState('1');

    const selecionarAba = (aba) => {
        setAbaSelecionada(aba);
    }

    useEffect(() => {
        chamadaBanners()
    }, [])

    const chamadaBanners = () => {
        const config = new Configurations();
        axios.get(config.apiBasePath + `/conteudo-cile/banners`)
            .then(response => {
                setBanners(response.data.banners)
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
                setLoading(false)
            });
    }

    const adicionarBanner = (_idResposta) => {
        history.push(`banners/novo-banner`)
    }


    return (
        <div className="cile-remessas">
            <div className="row">
                <div className="col-12 py-2">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-4 text-center text-lg-left">
                            <h2 className="title-1 d-none d-lg-block">CILE - Banners</h2>
                        </div>
                        <div className="col-6 col-lg-4 text-center text-lg-center">
                            <button className="btn btn-outline-primary" type="button" onClick={adicionarBanner}>
                                incluir banner
                            </button>
                        </div>
                        <div className="col-6 col-lg-4 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="no-gutters align-items-center py-lg-4 px-lg-3">


                    {loading ?
                        <div className="d-flex justify-content-center w-100">
                            <div className="spinner-border text-primary" role="status" />
                        </div>
                        :
                        <>
                            <Nav tabs>
                                <NavItem className="aba-bsmais text-center">
                                    <NavLink className={abaSelecionada === '1' ? 'classe-ativada-bsmais' : 'classe-inativa'} onClick={() => { selecionarAba('1'); }}>
                                        Carrossel
                                    </NavLink>
                                </NavItem>
                                <NavItem className="aba-hub text-center">
                                    <NavLink className={abaSelecionada === '2' ? 'classe-ativada-hub' : 'classe-inativa'} onClick={() => { selecionarAba('2'); }}>
                                        Youtube
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={abaSelecionada}>
                                <TabPane tabId="1">
                                    <ContentCileList
                                        conteudo={banners.welcome}
                                        setLoading={setLoading}
                                        chamadaBanners={chamadaBanners}
                                        youtube={false}
                                    />
                                </TabPane>
                                <TabPane tabId="2">
                                    <ContentCileList
                                        conteudo={banners.youtube}
                                        setLoading={setLoading}
                                        chamadaBanners={chamadaBanners}
                                        youtube={true}
                                    />
                                </TabPane>
                            </TabContent>
                        </>
                    }
                </div>
            </div>
        </div>
    )
}


export default withRouter(CileContentBanners);